export const timelineData = [
  {
    id: "stuttgart-msc",
    title: "stuttgart-msc.title",
    location: "stuttgart-msc.location",
    date: "stuttgart-msc.date",
    description: "stuttgart-msc.description",
  },
  {
    id: "db-analyst",
    title: "db-analyst.title",
    location: "db-analyst.location",
    date: "db-analyst.date",
    description: "db-analyst.description",
  },
  {
    id: "db-intern",
    title: "db-intern.title",
    location: "db-intern.location",
    date: "db-intern.date",
    description: "db-intern.description",
  },
  {
    id: "gsoc",
    title: "gsoc.title",
    location: "gsoc.location",
    date: "gsoc.date",
    description: "gsoc.description",
  },
  {
    id: "vit-btech",
    title: "vit-btech.title",
    location: "vit-btech.location",
    date: "vit-btech.date",
    description: "vit-btech.description",
  },
];
